/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { PageInfoFragmentDoc } from '../pageInfo/pageInfo.g';
import { ErrorFragmentDoc } from '../error/error.g';
import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientFragment = { __typename: 'ClientType', id: string, createdAt: string, updatedAt: string, name: string, email?: string | null, domain: string, description?: string | null };

export type ClientQueryVariables = Types.Exact<{
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  clientKey?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ClientQuery = { __typename: 'Query', client?: { __typename: 'ClientType', id: string, createdAt: string, updatedAt: string, name: string, email?: string | null, domain: string, description?: string | null } | null };

export type ClientsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  clientId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  name_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  domain_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  email_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sortBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ClientsQuery = { __typename: 'Query', clients?: { __typename: 'ClientTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ClientTypeEdge', node?: { __typename: 'ClientType', id: string, createdAt: string, updatedAt: string, name: string, email?: string | null, domain: string, description?: string | null } | null } | null>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ClientsByUnresolvedNotificationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ClientsByUnresolvedNotificationsQuery = { __typename: 'Query', clients?: { __typename: 'ClientTypeConnection', edges: Array<{ __typename: 'ClientTypeEdge', node?: { __typename: 'ClientType', id: string, name: string, notifications?: { __typename: 'NotificationTypeConnection', aggregate?: { __typename: 'NotificationAggregateType', groupBy?: { __typename: 'NotificationAggregateGroupByFieldType', notificationGroups?: Array<{ __typename: 'NotificationGroupType', notificationType?: Types.NotificationEnum | null, count?: number | null } | null> | null } | null } | null } | null } | null } | null> } | null };

export type CreateClientMutationVariables = Types.Exact<{
  input: Types.CreateClientMutationInput;
}>;


export type CreateClientMutation = { __typename: 'Mutation', createClient?: { __typename: 'CreateClientMutation', client?: { __typename: 'ClientType', id: string, createdAt: string, updatedAt: string, name: string, email?: string | null, domain: string, description?: string | null } | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type UpdateClientMutationVariables = Types.Exact<{
  input: Types.UpdateClientMutationInput;
}>;


export type UpdateClientMutation = { __typename: 'Mutation', updateClient?: { __typename: 'UpdateClientMutation', client?: { __typename: 'ClientType', id: string, createdAt: string, updatedAt: string, name: string, email?: string | null, domain: string, description?: string | null } | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type DeleteClientMutationVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type DeleteClientMutation = { __typename: 'Mutation', deleteClient?: { __typename: 'DeleteClientMutation', success?: boolean | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type CreateExtensionInstallationScriptMutationMutationVariables = Types.Exact<{
  input: Types.CreateExtensionInstallationScriptInput;
}>;


export type CreateExtensionInstallationScriptMutationMutation = { __typename: 'Mutation', createExtensionInstallationScript?: { __typename: 'CreateExtensionInstallationScriptMutation', script?: string | null, configJson?: string | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };


export const ClientFragmentDoc = `
    fragment Client on ClientType {
  id
  createdAt
  updatedAt
  name
  email
  domain
  description
}
    `;
export const ClientDocument = `
    query Client($clientId: UUID, $clientKey: String) {
  client(id: $clientId, key: $clientKey) {
    ...Client
  }
}
    ${ClientFragmentDoc}`;

export const useClientQuery = <
      TData = ClientQuery,
      TError = unknown
    >(
      variables?: ClientQueryVariables,
      options?: Omit<UseQueryOptions<ClientQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Client'] : ['Client', variables],
    queryFn: fetcher<ClientQuery, ClientQueryVariables>(ClientDocument, variables),
    ...options
  }
    )};

useClientQuery.getKey = (variables?: ClientQueryVariables) => variables === undefined ? ['Client'] : ['Client', variables];

export const useInfiniteClientQuery = <
      TData = InfiniteData<ClientQuery>,
      TError = unknown
    >(
      variables: ClientQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Client.infinite'] : ['Client.infinite', variables],
      queryFn: (metaData) => fetcher<ClientQuery, ClientQueryVariables>(ClientDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientQuery.getKey = (variables?: ClientQueryVariables) => variables === undefined ? ['Client.infinite'] : ['Client.infinite', variables];


useClientQuery.fetcher = (variables?: ClientQueryVariables) => fetcher<ClientQuery, ClientQueryVariables>(ClientDocument, variables);

export const ClientsDocument = `
    query Clients($after: String, $before: String, $first: Int, $last: Int, $clientId: ID, $offset: Int, $name_Icontains: String, $domain_Icontains: String, $email_Icontains: String, $sortBy: String) {
  clients(
    after: $after
    before: $before
    first: $first
    last: $last
    id: $clientId
    offset: $offset
    name_Icontains: $name_Icontains
    domain_Icontains: $domain_Icontains
    email_Icontains: $email_Icontains
    sortBy: $sortBy
  ) {
    edges {
      node {
        ...Client
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    ${ClientFragmentDoc}
${PageInfoFragmentDoc}`;

export const useClientsQuery = <
      TData = ClientsQuery,
      TError = unknown
    >(
      variables?: ClientsQueryVariables,
      options?: Omit<UseQueryOptions<ClientsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Clients'] : ['Clients', variables],
    queryFn: fetcher<ClientsQuery, ClientsQueryVariables>(ClientsDocument, variables),
    ...options
  }
    )};

useClientsQuery.getKey = (variables?: ClientsQueryVariables) => variables === undefined ? ['Clients'] : ['Clients', variables];

export const useInfiniteClientsQuery = <
      TData = InfiniteData<ClientsQuery>,
      TError = unknown
    >(
      variables: ClientsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Clients.infinite'] : ['Clients.infinite', variables],
      queryFn: (metaData) => fetcher<ClientsQuery, ClientsQueryVariables>(ClientsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientsQuery.getKey = (variables?: ClientsQueryVariables) => variables === undefined ? ['Clients.infinite'] : ['Clients.infinite', variables];


useClientsQuery.fetcher = (variables?: ClientsQueryVariables) => fetcher<ClientsQuery, ClientsQueryVariables>(ClientsDocument, variables);

export const ClientsByUnresolvedNotificationsDocument = `
    query ClientsByUnresolvedNotifications {
  clients(first: 5, sortBy: "-unresolved_notification_count") {
    edges {
      node {
        id
        name
        notifications {
          aggregate {
            groupBy {
              notificationGroups {
                notificationType
                count
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useClientsByUnresolvedNotificationsQuery = <
      TData = ClientsByUnresolvedNotificationsQuery,
      TError = unknown
    >(
      variables?: ClientsByUnresolvedNotificationsQueryVariables,
      options?: Omit<UseQueryOptions<ClientsByUnresolvedNotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientsByUnresolvedNotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientsByUnresolvedNotificationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ClientsByUnresolvedNotifications'] : ['ClientsByUnresolvedNotifications', variables],
    queryFn: fetcher<ClientsByUnresolvedNotificationsQuery, ClientsByUnresolvedNotificationsQueryVariables>(ClientsByUnresolvedNotificationsDocument, variables),
    ...options
  }
    )};

useClientsByUnresolvedNotificationsQuery.getKey = (variables?: ClientsByUnresolvedNotificationsQueryVariables) => variables === undefined ? ['ClientsByUnresolvedNotifications'] : ['ClientsByUnresolvedNotifications', variables];

export const useInfiniteClientsByUnresolvedNotificationsQuery = <
      TData = InfiniteData<ClientsByUnresolvedNotificationsQuery>,
      TError = unknown
    >(
      variables: ClientsByUnresolvedNotificationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientsByUnresolvedNotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientsByUnresolvedNotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientsByUnresolvedNotificationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ClientsByUnresolvedNotifications.infinite'] : ['ClientsByUnresolvedNotifications.infinite', variables],
      queryFn: (metaData) => fetcher<ClientsByUnresolvedNotificationsQuery, ClientsByUnresolvedNotificationsQueryVariables>(ClientsByUnresolvedNotificationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientsByUnresolvedNotificationsQuery.getKey = (variables?: ClientsByUnresolvedNotificationsQueryVariables) => variables === undefined ? ['ClientsByUnresolvedNotifications.infinite'] : ['ClientsByUnresolvedNotifications.infinite', variables];


useClientsByUnresolvedNotificationsQuery.fetcher = (variables?: ClientsByUnresolvedNotificationsQueryVariables) => fetcher<ClientsByUnresolvedNotificationsQuery, ClientsByUnresolvedNotificationsQueryVariables>(ClientsByUnresolvedNotificationsDocument, variables);

export const CreateClientDocument = `
    mutation CreateClient($input: CreateClientMutationInput!) {
  createClient(input: $input) {
    client {
      ...Client
    }
    errors {
      ...Error
    }
  }
}
    ${ClientFragmentDoc}
${ErrorFragmentDoc}`;

export const useCreateClientMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClientMutation, TError, CreateClientMutationVariables, TContext>) => {
    
    return useMutation<CreateClientMutation, TError, CreateClientMutationVariables, TContext>(
      {
    mutationKey: ['CreateClient'],
    mutationFn: (variables?: CreateClientMutationVariables) => fetcher<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, variables)(),
    ...options
  }
    )};


useCreateClientMutation.fetcher = (variables: CreateClientMutationVariables) => fetcher<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, variables);

export const UpdateClientDocument = `
    mutation UpdateClient($input: UpdateClientMutationInput!) {
  updateClient(input: $input) {
    client {
      ...Client
    }
    errors {
      ...Error
    }
  }
}
    ${ClientFragmentDoc}
${ErrorFragmentDoc}`;

export const useUpdateClientMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateClientMutation, TError, UpdateClientMutationVariables, TContext>) => {
    
    return useMutation<UpdateClientMutation, TError, UpdateClientMutationVariables, TContext>(
      {
    mutationKey: ['UpdateClient'],
    mutationFn: (variables?: UpdateClientMutationVariables) => fetcher<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, variables)(),
    ...options
  }
    )};


useUpdateClientMutation.fetcher = (variables: UpdateClientMutationVariables) => fetcher<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, variables);

export const DeleteClientDocument = `
    mutation DeleteClient($clientId: UUID!) {
  deleteClient(id: $clientId) {
    success
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;

export const useDeleteClientMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteClientMutation, TError, DeleteClientMutationVariables, TContext>) => {
    
    return useMutation<DeleteClientMutation, TError, DeleteClientMutationVariables, TContext>(
      {
    mutationKey: ['DeleteClient'],
    mutationFn: (variables?: DeleteClientMutationVariables) => fetcher<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument, variables)(),
    ...options
  }
    )};


useDeleteClientMutation.fetcher = (variables: DeleteClientMutationVariables) => fetcher<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument, variables);

export const CreateExtensionInstallationScriptMutationDocument = `
    mutation CreateExtensionInstallationScriptMutation($input: CreateExtensionInstallationScriptInput!) {
  createExtensionInstallationScript(input: $input) {
    script
    configJson
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;

export const useCreateExtensionInstallationScriptMutationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateExtensionInstallationScriptMutationMutation, TError, CreateExtensionInstallationScriptMutationMutationVariables, TContext>) => {
    
    return useMutation<CreateExtensionInstallationScriptMutationMutation, TError, CreateExtensionInstallationScriptMutationMutationVariables, TContext>(
      {
    mutationKey: ['CreateExtensionInstallationScriptMutation'],
    mutationFn: (variables?: CreateExtensionInstallationScriptMutationMutationVariables) => fetcher<CreateExtensionInstallationScriptMutationMutation, CreateExtensionInstallationScriptMutationMutationVariables>(CreateExtensionInstallationScriptMutationDocument, variables)(),
    ...options
  }
    )};


useCreateExtensionInstallationScriptMutationMutation.fetcher = (variables: CreateExtensionInstallationScriptMutationMutationVariables) => fetcher<CreateExtensionInstallationScriptMutationMutation, CreateExtensionInstallationScriptMutationMutationVariables>(CreateExtensionInstallationScriptMutationDocument, variables);
